
import {
    FILE_UPLOADING,
    FILE_LOADING_ERROR,
    ADD_POST_HOME,
    IS_LOADING_ADD_POST_HOME,
    ADD_ZONE_POSTS,
    LOAD_ZONE_POSTS,
    ADD_ZONE_POSTS_ERROR,
    ERROR_ADD_POST_HOME,
    ADD_COUNT_SHARED_POST_PROFILE,
} from './types'
import { urlServer } from '../config/GlobalConstant'
import { createComment, createReplyComment } from '../actions/commentActions'
import inMemoryJWT from '../auth/inMemoryJwt';
import Swal from 'sweetalert2';
import localStorage from '../utils/hooks/useLocalStorage';

//file upload actions, how to upload media in post and comment

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export const fileUpload = (files, fileData, history, isProfessionalUser) => async dispatch => {
    console.log()
    dispatch({
        type: FILE_UPLOADING
    });

    await fetch(`${urlServer}posts/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`


            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: files// body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            var filesUploaded = respJson.data
            console.log()
            if (fileData.imgAndOrVideosGif.length === 1) {
                fileData.imgAndOrVideosGif[0].url = filesUploaded.url
            }
            else
                for (let i = 0; i < fileData.imgAndOrVideosGif.length; i++) {
                    fileData.imgAndOrVideosGif[i].url = filesUploaded[i].url
                }
            console.log()
            dispatch(createPost(fileData, history, isProfessionalUser))
        })
        .catch(error => {
            dispatch({
                type: ERROR_ADD_POST_HOME
            })
            console.log()
        })
}

export const fileUploadComment = (file, data) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/user/upload/media`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: file// body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (data.isReplyComment)
                dispatch(createReplyComment({ text: data.text, type: data.type, imgOrAudio: respJson.data.url }, data.commentID, data.isProfessional))
            else
                dispatch(createComment({ text: data.text, type: data.type, imgOrAudio: respJson.data.url }, data.postID, data.isProfessional))
        })
        .catch(error => {
            dispatch({
                type: FILE_LOADING_ERROR
            })
            console.log()
        })
}

export const checkPoints = (_idEc, action) => async dispatch => {
    await fetch(`${urlServer}pointbanks/get-by-entity`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            entityId: _idEc
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true && respJson.data[0]?.availablePoints > 0) {
                action()
            } else {
                Toast.fire({
                    title: "No tienes ecopuntos",
                    icon: 'error'
                })
            }
        })

}
export const createPost = (post, history, close, _idEc) => async dispatch => {
    // const accessToken= inMemoryJWT.getToken()
    dispatch({
        type: IS_LOADING_ADD_POST_HOME

    })
    await fetch(`${urlServer}posts/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: post // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Publicado con éxito'
                })

                if (_idEc) {
                    close()
                    dispatch({
                        type: ADD_POST_HOME,
                        payload: respJson.data
                    })
                    history.replace(`/Profile/${localStorage().getItem('idUser')}/Campaigns/${respJson.data._id}`)
                } else {
                    // history.go(0)
                    close()
                    dispatch({
                        type: ADD_POST_HOME,
                        payload: respJson.data
                    })
                    dispatch({
                        type: "ADD_POST_USER",
                        payload: respJson.data
                    })
                }
            }
        })
        .catch(error => {
            console.log()
            dispatch({
                type: FILE_LOADING_ERROR
            })
        })
}
export const sharePost = (post, close) => async dispatch => {
    // const accessToken= inMemoryJWT.getToken()

    await fetch(`${urlServer}posts/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: post // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Compartido con éxito'
                })
                dispatch({
                    type:ADD_COUNT_SHARED_POST_PROFILE
                })
                close()


            }
        })
        .catch(error => {
            console.log()
            dispatch({
                type: FILE_LOADING_ERROR
            })
        })
}
export const createZonePost = (post, close) => async dispatch => {
    // const accessToken= inMemoryJWT.getToken()
    dispatch({
        type: LOAD_ZONE_POSTS
    })

    await fetch(`${urlServer}zoneposts/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: post // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            if (respJson.success === true) {
                close()

                Toast.fire({
                    icon: 'success',
                    title: 'Publicado con éxito'
                })
                //history.go(0)
                dispatch({
                    type: ADD_ZONE_POSTS,
                    payload: respJson.data
                })

            } else {
                dispatch({
                    type: ADD_ZONE_POSTS_ERROR
                })
            }
        })
        .catch(error => {
            console.log()
            dispatch({
                type: FILE_LOADING_ERROR
            })
        })
}
export const createPostStream = (post, history, isProfessionalUser, isShared) => async dispatch => {
    // const accessToken= inMemoryJWT.getToken()

    await fetch(`${urlServer}posts/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        // withCredentials: true,
        //credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify(post) // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Publicado con éxito'
                })
            }
        })
        .catch(error => {
            console.log()
            dispatch({
                type: FILE_LOADING_ERROR
            })
        })
}
export const fileUploadProfileImage = (formdata, setIsloadingProfilePicture, close) => async dispatch => {
    formdata.append('typePost', 2)
    formdata.append('defaultAlbum', 0)

    console.log();

    await fetch(`${urlServer}posts/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`

            // 'Content-Type': 'application/x-www-form-urlencoded',
        },

        body: formdata // body data type must match "Content-Type" header
    })
        .then(response => response.json())
        .then(respJson => {

            console.log()
            var dataPicProfile = respJson.data
            localStorage().setItem("picturProfile", dataPicProfile.multimedia.url.small)
            dispatch({
                type: "CHANGE_USER_PICTURE",
                payload: {
                    picture:dataPicProfile.multimedia,
                    id:respJson.data._id
                }
            })
            setIsloadingProfilePicture(false)
            close()

            /*   var ObjectPost = {}
              ObjectPost.description = ""
            
              ObjectPost.score = 0
              ObjectPost.taggedUsers = []
              ObjectPost.privacy = 0
              ObjectPost.typeCat = 2
              ObjectPost.albumsIDS = []
              dataPicProfile.type = type
              ObjectPost.imgAndOrVideosGif = [dataPicProfile]
              console.log()
              dispatch(createPost(ObjectPost, history)) */
        })

        .catch(error => {
            console.log()
        })
}


